<template>
  <section class="innerpages animate__animated animate__slideInRight">
    <div class="container ">
      <div class="row">
        <div class="col-md-12 listPage">
          <h1 class="text-truncate" :title="activeItem?.user_name">{{ activeItem?.user_name }}</h1>
          <h2 class="text-truncate" :title="activeItem?.project_name">{{ activeItem?.project_name }}</h2>
          <h3 class="text-truncate" :title="activeItem?.project_city">{{ activeItem?.project_city }}</h3>
          <div class="card">
            <b-table :items="activeItem?.ageing_breakdown || []" :fields="fields" :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc" sort-icon-right responsive="sm" show-empty tbody-tr-class="dataDivider">
              <template v-slot:empty="scope">
                <h5 class="noData">No Data</h5>
              </template>
              <template v-slot:cell(booked_count)="data">
                <span @click.stop="goToLeads(data.item, 'booked')">{{ data.value }}</span>
              </template>
              <template v-slot:cell(dead_count)="data">
                <span @click.stop="goToLeads(data.item, 'dead')">{{ data.value }}</span>
              </template>
            </b-table>
          </div>
          <div class="card p-3">
            <div @click="goToLeads()" class="d-flex justify-content-between align-items-center other-status">Total
              Assigned Leads
              <span class="icon-arrow"> {{ activeItem?.total_leads }} <svg class="mt-0" version="1.1" id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve">
                  <polygon
                    points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 ">
                  </polygon>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      sortBy: 'count',
      sortDesc: false
    }
  },
  mounted() {
    this.$store.dispatch('setActiveTitle', "Lead Ageing Report");
  },
  methods: {
    goToLeads(item, type) {
      this.$router.push({
        path: `/leads/for/lead_ageing_details/${this.activeItem.user_id}/projects/${this.activeItem.project_id}`,
        query: {
          ...(type && { "ageing_status_type": type }),
          ...(item?.ageing_time_range && { "ageing_time_range": item.ageing_time_range }),
          ...this.$route.query,
        }
      });
    },
  },
  computed: {
    activeItem() {
      return this.$store.getters.activeItem.data;
    },
    fields() {
      return [
        {
          key: 'duration_range',
          sortable: true,
          label: 'Days'
        },
        {
          key: 'booked_count',
          sortable: true,
          label: 'Booked'
        },
        {
          key: 'dead_count',
          sortable: true,
          label: 'Dead'
        },
      ];
    }
  }
}
</script>

<style scoped>
.innerpages h1,
h2,
h3 {
  font-size: 20px;
  font-weight: 800;
  color: #000000;
  opacity: .2;
}

.other-status {
  font-weight: 500;
  font-size: 14px;
}

.icon-arrow {
  display: inline-flex;
  align-items: center;
  gap: 40px
}

@media screen and (width: 412px) {
  .icon-arrow{
    gap: 48px;
  }
}
@media screen and (width: 430px) {
  .icon-arrow{
    gap: 50px;
  }
}
</style>